module.exports = __webpack_public_path__ + "img/20200512_142440.c50060d9.jpg";